import { ResourceStatus } from '../../../../generated/hosting-service';
import iconUndeployError from '../../../../images/status/disable_error.svg';
import iconNotDeployed from '../../../../images/status/disabled.svg';
import iconUndeployPending from '../../../../images/status/disabling.svg';
import iconDeployError from '../../../../images/status/enable_error.svg';
import iconDeployed from '../../../../images/status/enabled.svg';
import iconDeployPending from '../../../../images/status/enabling.svg';

export const getServiceDeploymentStatusIconLabel = (
  deploymentStatus: ResourceStatus | undefined,
): { icon: string; label: string } => {
  switch (deploymentStatus) {
    case undefined:
    case ResourceStatus.DeleteCompleted:
      return { icon: iconNotDeployed, label: 'Not Deployed' };
    case ResourceStatus.DeletePending:
      return { icon: iconUndeployPending, label: 'Undeploying' };
    case ResourceStatus.DeleteError:
      return { icon: iconUndeployError, label: 'Error Undeploying' };
    case ResourceStatus.Ready:
      return { icon: iconDeployed, label: 'Deployed' };
    case ResourceStatus.CreatePending:
      return { icon: iconDeployPending, label: 'Deploying' };
    case ResourceStatus.CreateError:
      return { icon: iconDeployError, label: 'Error Deploying' };
    case ResourceStatus.ScaledDown:
      return { icon: iconNotDeployed, label: 'Scaled Down' };
  }
};

/**
 * Returns icon for the storage state.
 */
export const getStorageStateIconLabel = (
  storageState: ResourceStatus | undefined,
): { icon: string; label: string } => {
  switch (storageState) {
    case undefined:
    case ResourceStatus.DeleteCompleted:
      return { icon: iconNotDeployed, label: 'Disabled' };
    case ResourceStatus.DeletePending:
      return { icon: iconUndeployPending, label: 'Disabling' };
    case ResourceStatus.DeleteError:
      return { icon: iconUndeployError, label: 'Error Disabling' };
    case ResourceStatus.Ready:
      return { icon: iconDeployed, label: 'Enabled' };
    case ResourceStatus.CreatePending:
      return { icon: iconDeployPending, label: 'Enabling' };
    case ResourceStatus.CreateError:
      return { icon: iconDeployError, label: 'Error Enabling' };
    case ResourceStatus.ScaledDown:
      return { icon: iconNotDeployed, label: 'Disabled' };
  }
};

/**
 * Returns icon for the Deployment State.
 */
export const getDeploymentStateIconLabel = (
  deploymentState: boolean | null | undefined,
): { icon: string; label: string } => {
  if (deploymentState === true) {
    return { icon: iconDeployed, label: 'Deployed' };
  } else {
    return { icon: iconNotDeployed, label: 'Not Deployed' };
  }
};
